// Schema.org JSON-LD builders. Only real, visible data is used; rich results are never guaranteed by Google.
const origin = () => window.location.origin;
const day = (iso) => (iso ? String(iso).slice(0, 10) : undefined);
const live = (iso) => !iso || day(iso) >= new Date().toISOString().slice(0, 10);

export const storeLd = (store, deals = []) => {
  const url = `${origin()}/store/${store.slug}`;
  const seller = { "@type": "Organization", name: store.name, ...(store.website ? { url: store.website } : {}) };
  const offers = (store.coupons || []).filter((c) => live(c.expires_at)).slice(0, 30).map((c) => ({
    "@type": "Offer", name: c.title, url: `${url}#coupon-${c.id}`, seller,
    ...(c.description ? { description: c.description.slice(0, 300) } : {}),
    ...(c.expires_at ? { validThrough: day(c.expires_at) } : {}),
  }));
  const products = deals.slice(0, 20).map((d) => ({ "@type": "Product", name: d.title, url: `${origin()}/deal/${d.slug}`, ...(d.image_url ? { image: d.image_url } : {}) }));
  const items = [...offers, ...products];
  return {
    "@context": "https://schema.org", "@type": "CollectionPage", name: `${store.name} deals & coupons`, url,
    ...(store.description ? { description: store.description } : {}),
    about: seller,
    ...(items.length ? { mainEntity: { "@type": "ItemList", numberOfItems: items.length,
      itemListElement: items.map((item, i) => ({ "@type": "ListItem", position: i + 1, item })) } } : {}),
  };
};

export const dealLd = (d) => {
  if (!d || !d.price) return null;
  const expired = d.status === "expired";
  return {
    "@context": "https://schema.org", "@type": "Product", name: d.title, description: d.meta_description || d.title,
    ...(d.image_url ? { image: d.image_url } : {}), ...(d.brand ? { brand: { "@type": "Brand", name: d.brand } } : {}),
    offers: {
      "@type": "Offer", priceCurrency: "INR", price: d.price, url: `${origin()}/deal/${d.slug}`,
      availability: expired ? "https://schema.org/Discontinued" : d.in_stock === false ? "https://schema.org/OutOfStock" : "https://schema.org/InStock",
      ...(d.expires_at ? { priceValidUntil: day(d.expires_at) } : {}),
      seller: { "@type": "Organization", name: d.merchant_name },
    },
  };
};
